//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoCheckboxBasic from './demos/DemoCheckboxBasic.vue'
import DemoCheckboxDense from './demos/DemoCheckboxDense.vue'
import DemoCheckboxColors from './demos/DemoCheckboxColors.vue'
import DemoCheckboxModelAsArray from './demos/DemoCheckboxModelAsArray.vue'
import DemoCheckboxIcon from './demos/DemoCheckboxIcon.vue'
import DemoCheckboxValue from './demos/DemoCheckboxValue.vue'
import DemoCheckboxStates from './demos/DemoCheckboxStates.vue'
import DemoCheckboxLabelSlot from './demos/DemoCheckboxLabelSlot.vue'
import DemoCheckboxInlineTextField from './demos/DemoCheckboxInlineTextField.vue'

// code
import {
  checkboxBasic,
  checkboxDense,
  checkboxColors,
  checkboxModelAsArray,
  checkboxIcon,
  checkboxValue,
  checkboxStates,
  checkboxLabelSlot,
  checkboxInlineTextField,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoCheckboxBasic,
    DemoCheckboxDense,
    DemoCheckboxColors,
    DemoCheckboxModelAsArray,
    DemoCheckboxIcon,
    DemoCheckboxValue,
    DemoCheckboxStates,
    DemoCheckboxLabelSlot,
    DemoCheckboxInlineTextField,
  },
  setup() {
    return {
      codeSnippets: {
        checkboxBasic,
        checkboxDense,
        checkboxColors,
        checkboxModelAsArray,
        checkboxIcon,
        checkboxValue,
        checkboxStates,
        checkboxLabelSlot,
        checkboxInlineTextField,
      },
    }
  },
}
